<template>
    <v-container class='text-left'>
        <div class="bodyPage">
            TESTE
        </div>
    </v-container>
</template>

<script>

export default {
    name: 'Acessos_permissoes',
    components: {},
    data() {
        return {

        }
    },
    methods: {
        
    },
    async mounted() {

    },

}
</script>
<style scoped>
.titlePage{
    font-size: 16px;
    font-weight: 700;
}
.bodyPage{
    margin-top:1em;
    padding:2em;
}
.verticalDivider{
    margin: 4em 2em;
}
.horisontalDivider{
    margin: 3em;
}
.colPadding{
    padding: 0 1em;
}
.cardHeader{
    display: grid;
    margin-bottom: 1em;
}
.title{
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 1em;
}
.fileColumn{
    margin-top: 1em;
    padding: 2em;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dragAndDropFile{
    border: 2px solid #afafaf;
    border-radius: 20px;
    min-height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-style: dashed;
}
.dragAndDropFile:hover{
    cursor: pointer;
    background-color: #ededed;
}
.boxItems{
    padding: 1em;
    display: grid;
    justify-items: center;
}
.inputFile{
    overflow: hidden;
    display: none;
}
.rowPadding{
    padding: 0 1em;
}
.rowPadding > .col{
    padding: 0px 10px;
}
.footer{
    position: relative;
    height: 14.5em;
}
.btn1{
    text-transform: none;
}
.floatBtn{
    position: absolute;
    right: 0;
    bottom: 0;
}
</style> 